export default "__VITE_ASSET__6beb2f44__"